/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CompanySearchRegularAi from './company-search-regular-ai-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompanySearchRegularAi {...validProps} />;
}
SvgComponent.iconName = 'companySearchRegularAi';

export const CompanySearchRegularAiIcon = svgIconWrapper(SvgComponent);
